import {
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Typography,
  Stack,
  Tooltip,
  Chip,
  Dialog
} from '@mui/material'
import { Close, MenuDown } from 'mdi-material-ui'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'
import { Variation } from '@/@core/services/app.service'
import { ColumnDef } from '@tanstack/react-table'
import { formatVariantInheritance, unique } from '@/@core/utils/utils'
import Slide from '@mui/material/Slide'
import TanStackTable from '@/@core/components/tanstack-tables'

import CloseIcon from '@mui/icons-material/Close'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import _ from 'lodash'
import { TransitionProps } from '@mui/material/transitions'
import { OMIM } from '@/views/analyze/OMIM'

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.75rem',
  color: 'inherit'
}))

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxWidth: 'none'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const ExportList = (props: any) => {
  const { t } = useTranslation()

  //

  const pagination = {
    pageIndex: 0,
    pageSize: 30
  }
  const [tKey, setTKey] = React.useState(0)
  const [page, setPage] = React.useState(pagination)
  const [sortQuery, setSortQuery] = React.useState<any>({
    f: -1
  })
  const [current, setCurrent] = React.useState<Variation | null>(null)
  const [OMIMOpen, setOMIMOpen] = React.useState(false)
  const [variantList, setVariantList] = React.useState<any[]>(props.data ?? [])
  const tableRef = React.useRef<any>()
  const [backop, setBackop] = React.useState(true)

  const changeOMIMChecked = (value: boolean, _id: string, phenoMim: string) => {
    const a = tableRef.current.dataMemo

    const temp = _.cloneDeep(a)
    const flag = temp.find((items: any) => items._id === _id)

    if (flag && flag.OMIM && flag.OMIM.omimData) {
      const omimData = flag.OMIM.omimData
      const find = omimData.find((item: any) => item.phenoMim === phenoMim)

      if (find) {
        find.isCheck = value

        setTKey(Math.random())

        setVariantList(temp)
      }
    }
  }

  React.useEffect(() => {
    setVariantList(props.data)
  }, [props.data])

  return (
    <Box minWidth={1200}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t('Variant list')}
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <Close />
      </IconButton>

      <DialogContent dividers>
        <Grid container width={'100%'} height={'100%'} spacing={4}>
          <Grid item xs={12}>
            <Stack spacing={6} width="100%">
              <TanStackTable
                columns={props.columns ?? []}
                data={variantList}
                pagination={{
                  pageIndex: 1,
                  pageSize: 30
                }}
                pageCount={variantList.length}
                setRowSelection={(rowSelection: number[]) => {
                  // setSelectRowKey(rowSelection)
                  // if (data)
                  //   props.setSelectRowKey &&
                  //     props.setSelectRowKey(
                  //       data
                  //         ?.filter((item: any, index: number) =>
                  //           rowSelection.some((i) => i === index)
                  //         )
                  //         .map((item) => {
                  //           return {
                  //             ...item,
                  //             analysisItemType
                  //           }
                  //         })
                  //     )
                }}
                setPagination={setPage}
                setSortQuery={setSortQuery}
                sorting={[]}
                isFetching={false}
                setPage={null}
                variantCount={0}
                totalCount={0}
                ref={tableRef}
                disabledExpand={true}
                analysisInfo={props.analysisInfo}
              />
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{
            mt: 3,
            mb: 3
          }}
          variant={'outlined'}
          onClick={props.handleClose}
        >
          {t('close')}
        </Button>

        {/* <Button
          sx={{
            mt: 3,
            mb: 3
          }}
          variant={'contained'}
          onClick={() => {
            const a = tableRef.current.dataMemo
            const arr = _.cloneDeep(a ?? [])

            arr.map((items: any) => {
              if (items && items.OMIM && items.OMIM.omimData) {
                items.OMIM.omimData = items.OMIM.omimData
                  .filter((item: any) => item.isCheck)
                  .map((item: any) => {
                    delete item.phenoDescription

                    delete item.phenoClinicalFeatures

                    return item
                  })

                items['OMIMValue_OMIM'] = items.OMIM?.omimData
                  .map((item: any) => {
                    const inheritances: string[] = []

                    if (
                      item &&
                      item.clinicalSynopsis &&
                      item.clinicalSynopsis.INHERITANCE &&
                      Array.isArray(item.clinicalSynopsis.INHERITANCE)
                    ) {
                      item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                        inheritances.push(str.toLowerCase())
                      )
                    }
                    const inheritance = formatVariantInheritance(
                      Array.from([...new Set(inheritances)]).join(',')
                    )

                    return {
                      ...item,
                      inheritance
                    }
                  })
                  .map(
                    (items: any) =>
                      `(${items.inheritance ? items.inheritance : '.'})-${
                        items.phenoName
                      }-${items.pheno_name_cn}`
                  )
                  .join(';')

                items.Index = `\t${items?.Index?.accountTotal} / ${items?.Index?.userTotalSamples}`

                items.GeneIndex = `\t${items?.GeneIndex?.accountTotal} / ${items?.GeneIndex?.platformTotal}`

                delete items.OMIM

                delete items.transcript_list

                delete items.Index

                delete items.GeneIndex
              }

              return items
            })

            //

            props.exportVariantsList && props.exportVariantsList(arr)
          }}
        >
          {t('export')}
        </Button> */}

        <Button
          sx={{
            mt: 3,
            mb: 3
          }}
          variant={'contained'}
          onClick={() => {
            const a = tableRef.current.dataMemo
            const arr = _.cloneDeep(a ?? [])

            arr.map((items: any) => {
              if (items && items.OMIM && items.OMIM.omimData) {
                const newOMIMData = items.OMIM?.geneDiseaseTranslated?.data
                  ? items.OMIM?.geneDiseaseTranslated?.data
                  : items.omim_curate_phenotypes
                  ? items.omim_curate_phenotypes
                  : []
                items['OMIMValue_OMIM'] = `${unique(newOMIMData, 'disease')
                  .map((item: { genetic_mode: any; disease: any }) => {
                    return `${item.genetic_mode}--${item.disease}`
                  })
                  .filter((item) => item)
                  .join(',')}`

                items.Index = `\t${items?.Index?.accountTotal} / ${
                  items?.Index?.userTotalSamples
                } \n${items?.Index?.platformTotal} / ${
                  items?.Index?.glsTotalSamples + items?.Index?.btgTotalSamples
                }`

                items.GeneIndex = `\t${items?.GeneIndex?.accountTotal} / ${items?.GeneIndex?.platformTotal}`

                delete items.OMIM

                delete items.transcript_list

                // delete items.Index

                // delete items.GeneIndex
              }

              return items
            })

            //

            props.exportVariantsListXlsx && props.exportVariantsListXlsx(arr)
          }}
        >
          {`${t('export')} xlsx`}
        </Button>
      </DialogActions>

      {/* OMIM */}

      <BootstrapDialog
        onClose={() => setOMIMOpen(!OMIMOpen)}
        aria-labelledby="customized-dialog-title"
        open={OMIMOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {`${t('Clinical Synopsis')}(Gene:${current?.gene})`}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setOMIMOpen(!OMIMOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ maxWidth: '100%', minHeight: 300 }}>
          <Box height={'100%'} width={'100%'}>
            <OMIM
              params={current}
              setBackop={setBackop}
              analysisInfo={props.analysisInfo}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </Box>
  )
}
export default ExportList
